module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-float-right ls-no-margin",
    attrs: {
      "to": {
        name: 'new_customer'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.button.include_customer')))])])], 1), _vm._v(" "), _c('flash-message'), _vm._v(" "), (!_vm.error.status) ? _c('div', [_c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('filter-customers'), _vm._v(" "), (_vm.customers.length) ? _c('table', {
    staticClass: "ls-table ls-table-striped ls-sm-space"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.id')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.client_name')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.company_name')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.person_type')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.status')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.customers), function(customer, index) {
    return _c('tr', {
      attrs: {
        "data-test": "customer"
      }
    }, [_c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "data-test": "customers.id"
      }
    }, [_vm._v(_vm._s(customer.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "customers.name"
      }
    }, [_vm._v("\n            " + _vm._s(customer.name) + "\n            "), _c('small', {
      staticClass: "ls-xs-margin-top ls-display-block-lg"
    }, [_vm._v(_vm._s(customer.email))])]), _vm._v(" "), (customer.company_name) ? _c('td', {
      attrs: {
        "data-test": "customers.company_name"
      }
    }, [_vm._v(_vm._s(customer.company_name))]) : _c('td', {
      attrs: {
        "data-test": "customers.company_name"
      }
    }, [_vm._v(" - ")]), _vm._v(" "), (customer.kind === 'P') ? _c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "data-test": "customers.type"
      }
    }, [_vm._v(_vm._s(_vm.$t('customers.show.personal')))]) : _c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "data-test": "customers.type"
      }
    }, [_vm._v(_vm._s(_vm.$t('customers.show.customer_person')))]), _vm._v(" "), (customer.active) ? _c('td', {
      staticClass: "active",
      attrs: {
        "data-test": "customers.status"
      }
    }, [_c('span', {
      staticClass: "ls-display-inline-block"
    }, [_vm._v(_vm._s(_vm.$t('customers.main.active')))])]) : _c('td', {
      staticClass: "inactive",
      attrs: {
        "data-test": "customers.status"
      }
    }, [_c('span', {
      staticClass: "ls-display-inline-block"
    }, [_vm._v(_vm._s(_vm.$t('customers.main.inactive')))])]), _vm._v(" "), _c('td', [_c('regroup', {
      staticClass: "ls-float-right",
      attrs: {
        "width": 1675
      }
    }, [_c('router-link', {
      staticClass: "ls-btn ls-no-margin-bottom ls-no-margin-top ls-xs-margin-right",
      attrs: {
        "to": {
          name: 'edit_customer',
          params: {
            id: customer.id
          }
        }
      },
      slot: "button"
    }, [_vm._v(_vm._s(_vm.$t('customers.main.edit')))]), _vm._v(" "), _c('router-link', {
      staticClass: "ls-btn ls-no-margin",
      attrs: {
        "to": {
          name: 'customers_details',
          params: {
            id: customer.id
          }
        }
      },
      slot: "button"
    }, [_vm._v(_vm._s(_vm.$t('customers.main.details')))]), _vm._v(" "), _c('dropdown', {
      class: 'ls-pos-right',
      attrs: {
        "list": true
      },
      slot: "dropdown"
    }, [_c('button', {
      staticClass: "ls-btn ls-no-margin-bottom ls-no-margin",
      attrs: {
        "role": "combobox",
        "aria-expanded": "false"
      },
      slot: "trigger"
    }), _vm._v(" "), _c('ul', {
      staticClass: "ls-dropdown-nav",
      attrs: {
        "aria-hidden": "true"
      },
      slot: "list"
    }, [(customer.active) ? _c('li', [_c('authorized-link', {
      attrs: {
        "tag": "destroy_customer"
      }
    }, [_c('a', {
      staticClass: "ls-color-danger",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.setInactiveData(customer, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('application.button.inactive')))])])], 1) : _vm._e()])])], 1)], 1)])
  }))]) : _c('div', [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.getCustomers
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae0ada5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/customers/Main.vue
// module id = 736
// module chunks = 1